import { render, staticRenderFns } from "./LayoutForm.vue?vue&type=template&id=6b40b2ee&scoped=true"
import script from "./LayoutForm.vue?vue&type=script&lang=js"
export * from "./LayoutForm.vue?vue&type=script&lang=js"
import style0 from "./LayoutForm.vue?vue&type=style&index=0&id=6b40b2ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40b2ee",
  null
  
)

export default component.exports